export enum ErrorType {
  KIOSK_FULL = 'KIOSK_FULL',
  KIOSK_ERROR = 'KIOSK_ERROR',
  COURTESY_UNAVAILABLE = 'COURTESY_UNAVAILABLE',
}
